import { Button } from '@octopus-do/octopus-storybook'
import { useEffect } from 'react'

const CancelCrawling = (props) => {
  const { cancelButton, confirmCb } = props

  useEffect(() => {
    function onDocumentKeydown(e) {
      if (e.which === 8 || e.which === 13) {
        confirmCb()
      }
    }

    document.addEventListener('keydown', onDocumentKeydown)

    return function close() {
      document.removeEventListener('keydown', onDocumentKeydown)
    }
  })

  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">Stop crawling</div>

      <div className="System-dialog__description">
        <p>
          If stopped now, the sitemap may be incomplete with pages missing. Do
          you wish to proceed with partial result?
        </p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="Stop and show result"
            onClick={confirmCb}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}

export default CancelCrawling
